import { fabric } from "fabric";

const [PLAY, PAUSE, STOP] = [0, 1, 2];

const Gif = fabric.util.createClass(fabric.Image, {
  type: "gif",
  superType: "image",
  status: null,
  options: {},
  dataUrl: null,
  delay: 0,
  frameWidth: 0,
  framesLength: 0,
  start: null,
  framesIndex: 0,
  initialize(element, options) {
    options = options || {};
    const { onLoaded, loaded } = options;
    this.options = options || {};
    this.callSuper("initialize", element, options);
  },
  play() {
    this.status = PLAY;
    this.dirty = true;
  },
  pause() {
    this.status = PAUSE;
    this.dirty = false;
  },
  stop() {
    this.status = STOP;
    this.dirty = false;
  },
  getStatus() {
    return ["Playing", "Paused", "Stopped"][this.status];
  },
  getSrc(filtered) {
    var element = filtered ? this._element : this._originalElement;
    if (element && filtered) {
      if (element.toDataURL) {
        return element.toDataURL();
      }

      if (this.srcFromAttribute) {
        return element.getAttribute("src");
      } else {
        return element.src;
      }
    } else {
      return this.src || "";
    }
  },
  _render(ctx) {
    if (!this.dataUrl) {
      return;
    }
    if (
      this.status === PAUSE ||
      (this.status === STOP && this.framesIndex === 0)
    )
      return;
    const now = performance.now();
    const delta = now - this.start;
    if (delta > this.delay) {
      this.start = now;
      this.framesIndex++;
    }
    if (this.framesIndex === this.framesLength || this.status === STOP)
      this.framesIndex = 0;

    const sprite = this.getElement();
    ctx.drawImage(
      sprite,
      this.frameWidth * this.framesIndex,
      0,
      this.frameWidth,
      sprite.height,
      -this.width / 2,
      -this.height / 2,
      this.frameWidth,
      sprite.height
    );
  },
});

// Gif.fromObject = (options, callback) => {
//   console.log(options);
//   return callback(new Gif(options));
// };

/**
 * Creates an instance of fabric.Image from its object representation
 * @static
 * @param {Object} object Object to create an instance from
 * @param {Function} callback Callback to invoke when an image instance is created
 */
Gif.fromObject = function (_object, callback) {
  var object = fabric.util.object.clone(_object);
  fabric.util.loadImage(
    object.src,
    function (img, isError) {
      if (isError) {
        callback && callback(null, true);
        return;
      }
      fabric.Gif.prototype._initFilters.call(
        object,
        object.filters,
        function (filters) {
          object.filters = filters || [];
          fabric.Gif.prototype._initFilters.call(
            object,
            [object.resizeFilter],
            function (resizeFilters) {
              object.resizeFilter = resizeFilters[0];
              fabric.util.enlivenObjects(
                [object.clipPath],
                function (enlivedProps) {
                  object.clipPath = enlivedProps[0];
                  var image = new fabric.Gif(img, object);
                  callback(image, false);
                }
              );
            }
          );
        }
      );
    },
    null,
    object.crossOrigin
  );
};

window.fabric.Gif = Gif;

export default Gif;
